import React, { useEffect } from 'react';
import config from '../../config.json';
import axios from 'axios';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import styled from 'styled-components';
import { Button, } from '@mui/material';
import { FilterInput } from '../../../shared/components/FilterInput';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogActions, Grid, Autocomplete, TextField } from '@mui/material'
import Moment from 'moment'
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const TableWrapper = styled.div`
    .css-sghohy-MuiButtonBase-root-MuiButton-root {
         background-color: #F59300 !important;
    }
   
    .materialTableStyle {
        .filterAutocomplete{
    
            .closeIcon { 
                position: absolute;
                left: 450px;
                right: 0px;
                top: 20px;
                bottom: 0px;
            }
            .MuiFilledInput-root {
                background-color: #ffffff;
                border-radius: 0;
                height : 35px;
                padding-top : 0px;
            }
            .MuiFilledInput-input {
                padding: none;
                font-size: 12px;
                height : 10px;
            }
            .MuiFilledInput-underline:before {
                border: 0;
            }
            .MuiInputLabel-filled {
                transform: translate(12px,7px) scale(1);
                font-size: 12px;
            }
            .MuiFilledInput-underline:after {
                border: 0;
            }
            .MuiSelect-select:focus {
                background-color: #ffffff;
            }
            .MuiInputLabel-filled.MuiInputLabel-shrink {
                transform: translate(0px,-12px) scale(0.90) !important;
                color: #F59300;
            }}
        table {
            border-collapse: separate;
            border-spacing: 0 1em;
            width: 99%;
            margin: auto;
        }
        th:first-child, td:first-child {
            border-top-left-radius: 15px;
            border-bottom-left-radius: 15px;
        }
        th:last-child, td:last-child {
            border-top-right-radius: 15px;
            border-bottom-right-radius: 15px;
        }
        th {
            font-size: 12px !important;
            white-space: nowrap;
            padding-left: 8px;
            padding-right: 8px;
            padding-top: 10px;
            padding-bottom: 10px;
            background-color: #fff;
            border: none;
            color: #F59300;
            height: 55px;
        }
        .MuiTableSortLabel-active {
            color: #F59300;
        }
        .MuiTableSortLabel-root:hover {
            color: #F59300;
        }
        .MuiTableSortLabel-icon {
            color: #F59300 !important;
        }
        td {
            position: relative;
            font-size: 12px !important;
            color: #000;
            padding-left: 8px;
            padding-right: 8px;
            padding-top: 10px;
            padding-bottom: 10px;
            background-color: #fff;
            border: none;
            height: 60px;
        }
        tbody {
            tr {
                position: relative;
                border-radius: 15px;
                transition: all 0.3s linear;
              
                &:hover {
                    box-shadow: 0 10px 6px rgba(0,0,0,0.10), 0 6px 3px rgba(0,0,0,0.10);

                    .actionListDeleteIconPosition {
                        display: block;
                    }
                    .actionListEditIconPosition {
                        display: block;
                    }
                    .actionListVisibilityIconPosition {
                        display: block;
                    }
                }
            }
        }
        .actionListDeleteIconPosition {
            position: absolute;
            top: -16px;
            right: 15px;
            display: none;
            transition: all 0.3s linear;
        }
        .actionListEditIconPosition {
            position: absolute;
            top: -16px;
            right: 56px;
            display: none;
            transition: all 0.3s linear;
        }
        .actionListVisibilityIconPosition {
            position: absolute;
            top: -16px;
            right: 101px;
            display: none;
            transition: all 0.3s linear;
        }
        .actionBtn {
            padding: 8px;
            background-color: #ffffff;
            box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);

            &:hover {
                background-color: rgba(245,147,0,0.1);
                color: #F59300;
            }
        }
        .actionIcon {
            font-size: 17px;
        }
    }
    .filterRow {
        display: grid;
        grid-template-columns: 3fr 3fr 2fr 2fr 1fr 1fr;
        background-color: rgba(245, 147, 0, 0.1);
        height: 60px;
        border-radius: 15px;
        align-items: center;
        grid-column-gap: 10px;
        padding-left: 10px;
        padding-right: 10px;
        width: 99%;
        margin: auto;
    }
    .filterIconSize{
        font-size: 18px;
    }
    .filterDropdown {
        .MuiFilledInput-root {
            background-color: #ffffff;
            border-radius: 0;
        }
        .MuiFilledInput-input {
            padding: 5px 10px 5px;
            font-size: 12px;
        }
        .MuiFilledInput-underline:before {
            border: 0;
        }
        .MuiInputLabel-filled {
            transform: translate(12px,7px) scale(1);
            font-size: 12px;
        }
        .MuiFilledInput-underline:after {
            border: 0;
        }
        .MuiSelect-select:focus {
            background-color: #ffffff;
        }
        .MuiInputLabel-filled.MuiInputLabel-shrink {
            transform: translate(0px,-12px) scale(0.90) !important;
            color: #F59300;
        }
       
    }
`;

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}


const headCells = [
    { id: 'site', numeric: false, label: 'Project Site Name' },
    { id: 'task', numeric: false, label: 'Assigned Task' },
    { id: 'status', numeric: false, label: 'Status' },
    { id: 'createdDate', numeric: false, label: 'Created Date' },
    { id: 'closedDate', numeric: false, label: 'Closed Date' },
    { id: 'closedBy', numeric: false, label: 'Closed By' }
];

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'center' : 'left'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
};


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    customToastProgress: {
        backgroundColor: '#F59300',
    },
}));

export default function TaskList() {
    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    var [rows, setRows] = React.useState([]);
    var [filteredRows, setFilteredRows] = React.useState([]);
    var [search, setSearch] = React.useState("");
    var [disable, setDisable] = React.useState(true);
    const { id } = useParams();
    const token = config.TOKEN
    var [deletePopup, setDeletePopup] = React.useState(false);
    var [recordId, setRecordId] = React.useState();
    var [userName, setUserName] = React.useState("");
    var [userProfile, setUserProfile] = React.useState();
    const currentDate = Moment();
    var [siteData, setSiteData] = React.useState([]);
    var [siteId, setSiteId] = React.useState(-1);
    const [selectedStatus, setSelectedStatus] = React.useState("All");
    const [startDate, setStartDate] = React.useState(currentDate.clone().startOf('month').format("yyyy-MM-DD"));
    const [endDate, setEndDate] = React.useState(currentDate.clone().endOf('month').format("yyyy-MM-DD"));
    const errorMessage = () => toast("An error occured,try again later", { progressClassName: classes.customToastProgress });
    const closeTaskMessage = () => toast("Task Closed successfully!", { progressClassName: classes.customToastProgress });
    const deleteMessage = () => toast("An error occured, contact support", { progressClassName: classes.customToastProgress });

    const statusOption = [
        'All',
        'Open',
        'Closed'
    ]

    useEffect(() => {
        userProfile = localStorage.getItem("userProfile");
        userProfile = JSON.parse(userProfile);
        setUserProfile(userProfile);
        userName = userProfile.userName;
        setUserName(userName);
        getTaskList();
        getSiteData();
    }, [])

    const getTaskList = () => {
        var postData = {
            'siteId': siteId,
            'status': selectedStatus,
            'startDate': startDate,
            'endDate': endDate
        };
        const MOBILESURETY_SCHEDULE_URL = config.API_URL + "/api/sitetask"
        axios.post(MOBILESURETY_SCHEDULE_URL, postData, {
            headers: {
                'Authorization': `Basic ${token}`
            }
        })
            .then((res) => {
                if (res.data.successCode === 0) {
                    rows = res.data.data
                    setRows(rows);
                    filteredRows = rows;
                    setFilteredRows(filteredRows)
                    setDisable(false)
                } else {
                    errorMessage()
                }
            })
    }

    const getSiteData = () => {
        const MOBILESURETY_SCHEDULE_URL = config.API_URL + "/api/sites/basic"
        axios.get(MOBILESURETY_SCHEDULE_URL, {
            headers: {
                'Authorization': `Basic ${token}`
            }
        })
            .then((res) => {
                if (res.data.successCode === 0) {
                    siteData = res.data.data
                    setSiteData(siteData);
                } else {
                    errorMessage()
                }
            })
    }

    const handleTask = () => {
        getTaskList()
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const closeTask = () => {
        const MOBILESURETY_URL = config.API_URL + "/api/site/taskupdate/" + recordId + "/" + userName
        const token = config.TOKEN
        axios.get(MOBILESURETY_URL, {
            headers: {
                'Authorization': `Basic ${token}`
            }
        })
            .then((res) => {
                {
                    if (res.data.successCode === 0) {
                        closeTaskMessage()
                        getTaskList()
                    } else {
                        deleteMessage()
                    }
                    setTimeout(() => { setDeletePopup(false) }, 3000)
                }
            })
    }

    const openDeletePopup = (id) => {
        recordId = id;
        setRecordId(recordId)
        deletePopup = true;
        setDeletePopup(deletePopup);
    }

    return (

        <TableWrapper>
            <ToastContainer theme='dark' />
            <div className={`${classes.root} materialTableStyle`}>
                <div className='filterRow'>
                    <Autocomplete
                        options={siteData}
                        className='filterAutocomplete'
                        getOptionLabel={(option) => option.projectName}
                        onChange={(event, site) => {
                            site != null ? setSiteId(site.id) : setSiteId(-1)
                        }}
                        renderInput={(params) => <TextField {...params} fullWidth label="Select Site" variant='filled' />}
                    />
                    <Autocomplete
                        options={statusOption}
                        className='filterAutocomplete'
                        getOptionLabel={(option) => option}
                        onChange={(event, status) => {
                            setSelectedStatus(status);
                        }}
                        renderInput={(params) => <TextField {...params} fullWidth label="Select Status" variant='filled' />}
                    />
                    <div>
                        <FilterInput style={{ height: '35px' }} placeholder="Start Date(yyyy-mm-dd)" type="date" value={startDate} onChange={(event) => setStartDate(event.target.value)} />
                    </div>
                    <div>
                        <FilterInput style={{ height: '35px' }} placeholder="End Date(yyyy-mm-dd)" type="date" value={endDate} onChange={(event) => setEndDate(event.target.value)} />
                    </div>
                    <div></div>
                    <div>
                        <Button type='submit' variant='contained' color='primary' className='noShadow addBtn' onClick={handleTask}>
                            Search
                        </Button>
                    </div>
                </div>
                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            classes={classes}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                        />
                        <TableBody>

                            {stableSort(filteredRows, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((filteredRows, index) => {
                                    return (
                                        <TableRow
                                            hover
                                            tabIndex={-1}
                                            key={filteredRows.id}
                                        >

                                            <TableCell align="left">
                                                {filteredRows.site}
                                            </TableCell>
                                            <TableCell align="left">
                                                {filteredRows.task}
                                            </TableCell>
                                            <TableCell align="left">
                                                {filteredRows.status}
                                            </TableCell>
                                            <TableCell align="left">
                                                {Moment(Date.parse(filteredRows.createdDate)).format('MM/DD/YYYY HH:mm A')}
                                            </TableCell>
                                            <TableCell align="left">
                                                {filteredRows.closedDate != null ? filteredRows.closedDate = Moment(Date.parse(filteredRows.closedDate)).format('MM/DD/YYYY hh:mm A') : ""}
                                            </TableCell>
                                            <TableCell align="left">
                                                {filteredRows.closedBy}
                                                {/* <Switch
                                                    checked={filteredRows.active}
                                                    name="status"
                                                    color="warning"
                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                /> */}
                                                <div className="actionListDeleteIconPosition">
                                                    <Tooltip title="delete" aria-label="delete">
                                                        <IconButton className="actionBtn" aria-label="delete" onClick={() => { openDeletePopup(filteredRows.id) }}>
                                                            <DeleteIcon className="actionIcon" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Dialog open={deletePopup} closeonescape="true" maxWidth="true" >
                                                        <TableWrapper>
                                                            <DialogContent className="dialogStyle">
                                                                <div className={`${classes.root} materialTableStyle`}>
                                                                    Do you want to close this task?
                                                                </div>
                                                                <DialogActions>
                                                                    <Grid container spacing={4} className="mt-1">
                                                                        <Grid item xs={12} sm={12} md={12} className="text-center">
                                                                            <Button type="button" variant="outlined" color="primary" className="noShadow cancelBtn" onClick={() => setDeletePopup(false)}>
                                                                                No
                                                                            </Button>&nbsp;&nbsp;
                                                                            <Button type="submit" variant="contained" color="primary" className="noShadow addBtn" onClick={() => closeTask()}>
                                                                                Yes
                                                                            </Button>
                                                                        </Grid>
                                                                    </Grid>
                                                                </DialogActions>
                                                            </DialogContent>

                                                        </TableWrapper>
                                                    </Dialog>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    className="paginationLabel"
                    rowsPerPageOptions={[50, 100, 150]}
                    component="div"
                    count={filteredRows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        </TableWrapper>
    );
}


